module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-mask"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action === 'login'),
      expression: "action === 'login'"
    }],
    staticClass: "tw-panel",
    attrs: {
      "id": "login"
    }
  }, [(!_vm.login.logined) ? _c('form', {
    staticClass: "login-box",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.userLogIn($event)
      },
      "submit": function($event) {
        $event.preventDefault();
        _vm.userLogIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "login-box-header"
  }, [_c('div', {
    staticClass: "cancel"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("x")])], 1)]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.login.tips))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.username),
      expression: "login.username"
    }],
    attrs: {
      "action": "text",
      "placeholder": "username",
      "contenteditable": "false"
    },
    domProps: {
      "value": (_vm.login.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-box-header"
  }, [_c('div', {
    staticClass: "cancel"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("x")])], 1)]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s("早上好！" + _vm.login.username))]), _vm._v(" "), _c('p', [_vm._v("现在，你可以使用云备份来上传下载你的个人数据啦！")]), _vm._v(" "), _c('div', {
    staticClass: "btn-sheet"
  }, [_c('button', {
    staticClass: "btn-login-out",
    on: {
      "click": _vm.userLogOut
    }
  }, [_vm._v("退出登录")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action === 'cloud'),
      expression: "action === 'cloud'"
    }],
    staticClass: "tw-panel"
  }, [_c('div', {
    staticClass: "login-box-header"
  }, [_c('div', {
    staticClass: "cancel"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("x")])], 1)]), _vm._v(" "), (!_vm.login.logined) ? _c('p', [_vm._v("登录了才可以使用云备份哦！")]) : _c('p', [_vm._v("上传数据将会覆盖云端数据，下载数据也将覆盖本地数据，请小心操作哦")]), _vm._v(" "), _c('div', {
    staticClass: "btn-sheet"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": !_vm.login.logined
    },
    on: {
      "click": _vm.uploadData
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": !_vm.login.logined
    },
    on: {
      "click": _vm.downloadDate
    }
  }, [_vm._v("下载")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action === 'about'),
      expression: "action === 'about'"
    }],
    staticClass: "tw-panel"
  }, [_c('div', {
    staticClass: "login-box-header"
  }, [_c('div', {
    staticClass: "cancel"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("x")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-sheet"
  }, [_c('button', {
    staticClass: "btn-login",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Time To Work")]), _vm._v(" is a time-based Todo-list Web App"), _c('br'), _c('b', [_vm._v("enjoy")]), _vm._v(" your time!"), _c('br'), _c('br'), _vm._v("ps:click the date and choose one, the default is today.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "btn-sheet"
  }, [_c('span', [_vm._v("@2017")]), _vm._v(" "), _c('a', [_c('strong', [_vm._v("Ningersan")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04206b8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 31
// module chunks = 0